import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DxButtonModule } from "devextreme-angular";
import { RouterModule } from "@angular/router";
import { AppGlobals } from "src/app/app.globals";

@Component({
    selector: "user-administration",
    imports: [CommonModule, DxButtonModule, RouterModule],
    templateUrl: "./user-administration.page.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./user-administration.page.css"]
})
export class UserAdministrationComponent implements OnInit {
  constructor(private appGlobals: AppGlobals) {}

  ngOnInit(): void {
    this.appGlobals.$headerTitle.next(
      $localize`:@@configuration:Configuration`,
    );
  }
}
